var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "offering-options-toolbar-view",
      class: {
        "offering-options-toolbar-view-with-preview": !!_vm.previewModel,
      },
    },
    [
      _c("div", { staticClass: "offering-options-toolbar-view-container" }, [
        _vm.previewModel
          ? _c(
              "div",
              {
                staticClass: "offering-options-toolbar-view-preview-container",
              },
              [
                _c("EditorPreview2DView", {
                  attrs: {
                    "bleed-margin": _vm.bleedMargin,
                    "offering-frame-model": _vm.offeringFrameModel,
                    "offering-model": _vm.internalValue,
                    "page-model": _vm.pageModel,
                    "page-objects": _vm.pageObjects,
                    "scaling-base": !_vm.isMobile ? undefined : "width",
                    value: _vm.previewModel,
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _c(
          "div",
          { staticClass: "offering-options-toolbar-view-options-container" },
          [
            _vm._l(
              _vm.selectedOptionsFiltered,
              function (offeringOption, index) {
                return [
                  _c("div", { staticClass: "offering-option" }, [
                    _c("div", { staticClass: "offering-option-name" }, [
                      _vm._v(_vm._s(_vm.getOfferingOptionName(offeringOption))),
                    ]),
                    _c(
                      "div",
                      { staticClass: "offering-option-value-container" },
                      [
                        !_vm.isMobile
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "scroll-button-container scroll-button-container-left",
                                class: {
                                  "scroll-button-container-show":
                                    _vm.shouldShowScrollButton(
                                      offeringOption.name,
                                      "left"
                                    ),
                                },
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "scroll-button",
                                    on: {
                                      click: function ($event) {
                                        return _vm.onScrollButtonClick(
                                          offeringOption.name,
                                          "left"
                                        )
                                      },
                                      mousedown: function ($event) {
                                        return _vm.onScrollButtonMouseDown(
                                          offeringOption.name,
                                          "left"
                                        )
                                      },
                                      touchstart: function ($event) {
                                        return _vm.onScrollButtonMouseDown(
                                          offeringOption.name,
                                          "left"
                                        )
                                      },
                                    },
                                  },
                                  [_c("IconComponent", [_vm._v("arrow_back")])],
                                  1
                                ),
                              ]
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          {
                            staticClass: "offering-option-value",
                            attrs: {
                              "data-offering-option-name": offeringOption.name,
                              "data-button-toggle-group-horizontal-space":
                                !_vm.isMobile ? 38 : undefined,
                            },
                            on: { scroll: _vm.onOfferingOptionValueScroll },
                          },
                          [
                            _c(
                              "ButtonToggleGroupComponent",
                              {
                                class:
                                  _vm.offeringOptionClasses(offeringOption),
                                style: _vm.offeringOptionStyles(offeringOption),
                                attrs: {
                                  value:
                                    offeringOption.value.id ||
                                    offeringOption.value.offeringid,
                                },
                                on: {
                                  change: function ($event) {
                                    return _vm.onOfferingOptionChange(
                                      offeringOption,
                                      $event
                                    )
                                  },
                                },
                              },
                              _vm._l(
                                _vm.productOptionValuesToShow(offeringOption),
                                function (productOptionValue) {
                                  return _c("ButtonToggleComponent", {
                                    key:
                                      productOptionValue.id ||
                                      productOptionValue.offeringid,
                                    attrs: {
                                      "inverse-layout":
                                        _vm.isProductOptionValueInverseLayout(
                                          offeringOption
                                        ),
                                      name: offeringOption.tag,
                                      value:
                                        productOptionValue.id ||
                                        productOptionValue.offeringid,
                                      variant:
                                        _vm.productOptionValueVariant(
                                          offeringOption
                                        ),
                                    },
                                    scopedSlots: _vm._u(
                                      [
                                        productOptionValue.image
                                          ? {
                                              key: "content",
                                              fn: function () {
                                                return [
                                                  _c("img", {
                                                    staticClass:
                                                      "offering-option-value-image",
                                                    attrs: {
                                                      src: productOptionValue.image,
                                                    },
                                                  }),
                                                ]
                                              },
                                              proxy: true,
                                            }
                                          : null,
                                        {
                                          key: "default",
                                          fn: function () {
                                            return [
                                              _vm._v(
                                                _vm._s(
                                                  _vm.getOfferingOptionValueLabel(
                                                    productOptionValue
                                                  )
                                                )
                                              ),
                                            ]
                                          },
                                          proxy: true,
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  })
                                }
                              ),
                              1
                            ),
                          ],
                          1
                        ),
                        !_vm.isMobile
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "scroll-button-container scroll-button-container-right",
                                class: {
                                  "scroll-button-container-show":
                                    _vm.shouldShowScrollButton(
                                      offeringOption.name,
                                      "right"
                                    ),
                                },
                              },
                              [
                                _c(
                                  "button",
                                  {
                                    staticClass: "scroll-button",
                                    on: {
                                      click: function ($event) {
                                        return _vm.onScrollButtonClick(
                                          offeringOption.name,
                                          "right"
                                        )
                                      },
                                      mousedown: function ($event) {
                                        return _vm.onScrollButtonMouseDown(
                                          offeringOption.name,
                                          "right"
                                        )
                                      },
                                      touchstart: function ($event) {
                                        return _vm.onScrollButtonMouseDown(
                                          offeringOption.name,
                                          "right"
                                        )
                                      },
                                    },
                                  },
                                  [
                                    _c("IconComponent", [
                                      _vm._v("arrow_forward"),
                                    ]),
                                  ],
                                  1
                                ),
                              ]
                            )
                          : _vm._e(),
                      ]
                    ),
                  ]),
                  index !== _vm.selectedOptionsFiltered.length - 1
                    ? _c("divider", { staticClass: "divider horizontal full" })
                    : _vm._e(),
                ]
              }
            ),
            _c(
              "div",
              {
                staticClass: "offering-options-price-container",
                class: {
                  "offering-options-price-container-hidden":
                    _vm.isMobile && _vm.previewModel,
                },
              },
              [
                _c("divider", { staticClass: "divider horizontal full" }),
                _c(
                  "div",
                  { staticClass: "offering-options-price" },
                  [
                    _vm.showPricing
                      ? _c("PriceView", {
                          staticClass: "offering-options-price-view",
                          attrs: {
                            cents: _vm.offeringModelPrice,
                            currency: _vm.currencyModel
                              ? _vm.currencyModel.id
                              : undefined,
                          },
                        })
                      : _vm._e(),
                    _c(
                      "span",
                      { staticClass: "offering-options-price-buttons" },
                      [
                        _c(
                          "ButtonComponent",
                          {
                            attrs: {
                              "font-size": "--font-size-s",
                              padding: [16, 60],
                            },
                            on: { click: _vm.onApplyClick },
                          },
                          [
                            _vm._v(
                              _vm._s(
                                _vm.$t("views.offeringOptionsToolbar.apply")
                              )
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          2
        ),
      ]),
      _vm.isMobile && _vm.previewModel
        ? _c(
            "div",
            { staticClass: "offering-options-price" },
            [
              _vm.showPricing
                ? _c("PriceView", {
                    staticClass: "offering-options-price-view",
                    attrs: {
                      cents: _vm.offeringModelPrice,
                      currency: _vm.currencyModel
                        ? _vm.currencyModel.id
                        : undefined,
                    },
                  })
                : _vm._e(),
              _c(
                "span",
                { staticClass: "offering-options-price-buttons" },
                [
                  _c(
                    "ButtonComponent",
                    {
                      attrs: {
                        "font-size": "--font-size-s",
                        padding: [16, 60],
                      },
                      on: { click: _vm.onApplyClick },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("views.offeringOptionsToolbar.apply"))
                      ),
                    ]
                  ),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }